
import { Options } from "vue-class-component";
import { Popup } from "vant";
import BasePage from "@/common/BasePage";

import AppUtil from "@/util/AppUtil";
import WxUtil from "@/util/WxUtil";

@Options({
  components: {
    [Popup.name]: Popup,
  },
})
/**购买畅想卡 */
export default class BuyEnioyCard extends BasePage {
  backcolor = "white";
  card = { cardPrice: "正在获取卡片信息...", id: 0,cardName:'超值畅享卡' };
  /**是否显示购买按钮 */
  showBuy=true;
  mounted() {
    AppUtil.request(
      {
        url: "/zhShareStore/enioyCard/getEnioyCardInfo",
        method: "post",
      },
      (res: any) => {
        console.log("畅享卡信息", res);
        this.card = res.data;
      }
    );
    /***type为1时，隐藏购买按钮 */
    this.$route.query.type?this.showBuy=false:"";
  }
  /**请求开通畅享卡 */
  pay_click() {
    AppUtil.request(
      {
        url: "/zhPay/wxpay/wxJSAPIPay",
        method: "post",
        data: {
          payType: 4,
          orderId: this.card.id,
        },
      },
      this.pay,"系统立马为您安排，请等待..."
    );
  }
  /**支付畅享卡费用 */
  pay(res: any) {
    let that = this;
    WxUtil.get_wx().then((wxsdk) => {
      wxsdk.chooseWXPay({
        timestamp: res.data.timeStamp, // 支付签名时间戳，注意微信jssdk中的所有使用timestamp字段均为小写。但最新版的支付后台生成签名使用的timeStamp字段名需大写其中的S字符
        nonceStr: res.data.nonceStr, // 支付签名随机串，不长于 32 位
        package: res.data.package, // 统一支付接口返回的prepay_id参数值，提交格式如：prepay_id=\*\*\*）
        signType: res.data.signType, // 微信支付V3的传入RSA,微信支付V2的传入格式与V2统一下单的签名格式保持一致
        paySign: res.data.paySign, // 支付签名
        success: function () {
          // 支付成功后的回调函数
          that.$router.push({
            path: "/user",
          });
        },
      });
    });
  }
}
